export const API_URL_GET_NOTIFICATION = `/api/v2/candidates/notifications`
export const API_URL_READ_ALL_NOTIFICATION = `/api/v2/candidates/notifications/mark_read_all`
export const API_URL_READ_NOTIFICATION = (id: string | number) => `/api/v2/candidates/notifications/${id}/read`
export const API_URL_COUNT_NOTIFICATION = `/api/v2/candidates/notifications/unread`
